import React, { Component } from "react";
import "./Login.css";
import { realDB, loadUser } from "../../firebase/firebase";
import "./Login.css";
import spinner from "../../Home/spinner.svg";
// import logo from "./logo.png";

class Login extends Component {
  state = {
    isLoading: false,
    email: "",
    name: "",
    error: false,
    errorMessage: "",
    _loading: false,
    forceDisable: false,
    forceUpdate: false,
  };
  onInputChange = (event) => {
    event.preventDefault();
    let value = event.target.value;
    this.setState({ [event.target.name]: value });
  };

  showLoginError = (err) => {
    this.setState({
      error: true,
      errorMessage: err.message ? err.message : err,
    });
  };

  validateEmail = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  onFormSubmit = async (event) => {
    if (this.state.email === "" || this.state.name === "") {
      this.setState({ error: true, errorMessage: "Enter your details" })
      return;
    }
    if (!this.validateEmail(this.state.email)) {
      this.setState({ error: true, errorMessage: "Invalid Email" })
      return;
    }
    this.setState({ _loading: true });
    event.preventDefault();
    try {
      this.setState({
        error: false,
        forceDisable: true,
      });
      let email = this.state.email.toLowerCase().trim();
      let name = this.state.name;
      let password = `${email}123456`;
      await loadUser(email, password, name, true);
      // this.setState({ _loading: false });
    } catch (err) {
      console.log(err);
      this.setState({
        forceDisable: false,
      });
      let error = "";
      switch (err.code) {
        case "auth/wrong-password":
          error = "Invalid username and password.";
          break;
        case "auth/user-not-found":
          error = "User not registered";
          break;
        case "auth/too-many-requests":
          error =
            "Too many invalid requests, please wait for 60 seconds before retrying";
          break;
        case "NoUserFound":
          error = "User not registered";
          break;
        default:
          error = err.message;
      }
      this.setState({
        _loading: false,
        error: true,
        errorMessage: error,
      });
    }
  };

  checkUserStatus = async (userId) => {
    return new Promise((resolve, reject) => {
      if (userId == undefined) {
        reject({
          code: "UserIDWasNull",
          message: "Please try again later",
        });
      } else {
        if (userId === "") {
          reject({
            code: "UserIDWasNull",
            message: "Please try again later",
          });
        }
      }
      var userCheck = realDB.ref("loggedInUser/" + userId);
      userCheck.once("value").then(
        (snapshot) => {
          if (snapshot.exists()) {
            let data = snapshot.val();
            if (data.state === "online") {
              let err = {
                code: "AlreadyLogged",
                message: "User Logged in from another system.",
              };
              reject(err);
            } else {
              resolve();
            }
          } else {
            resolve();
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  };

  render() {
    return (
      <>
        {this.state._loading && (
          <div className="loading">
            <img src={spinner} alt="" />
          </div>
        )}
        <section className={`login__div`}>
          <div
            className="login__img"
            style={{
              backgroundImage: `url(${"/assets/images/login/Login.png"})`,
            }}
          ></div>
          <div className="login__form">
            <div className="login__head">
              <img src="/assets/images/login/login-logo.png" alt="" />
            </div>
            <div className="login__inputs">
              <h1>Log In</h1>
              <input
                type="text"
                placeholder="Name"
                name="name"
                value={this.state.name}
                onChange={this.onInputChange}
                required={true}
              />
              <input
                type="text"
                placeholder="E mail"
                name="email"
                value={this.state.email}
                onChange={this.onInputChange}
                required={true}
              />
              {this.state.error &&
                <span className='error-message'>{this.state.errorMessage + " *"}</span>
              }
              <button onClick={this.onFormSubmit}>Log In</button>
            </div>
          </div>
        </section>
        <div id="loginrotate">
          <div className="loginphone"> </div>
          <div className="loginmessage">Please rotate your device! </div>
        </div>
      </>
    );
  }
}

export default Login;
